<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title pull-left">SALVAR ESSA BUSCA</h4>

    <button
      type="button"
      class="close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="bsModalRef.hide()"
    >
      <img
        src="{{
          BASE_IMG_URL
        }}assets/filtro-lateral-busca/icon-close.png"
        alt=""
      />
    </button>
  </div>
  <div class="modal-body">
    <div class="busca-salva">
      <p>Busca salva com sucesso!</p>
      <img
        src="{{
          BASE_IMG_URL
        }}assets/filtro-lateral-busca/icone-alerta-sucesso.webp"
        alt=""
      />
    </div>
    <div class="mensagem">
      <p>
        Agora você pode acessá-la rapidamente através do menu de filtros. Isso
        trará muito mais agilidade para encontrar obras com esses critérios
        aplicados sem ter que refazer a busca novamente.
      </p>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn" (click)="bsModalRef.hide()">
      <img
        src="{{
          BASE_IMG_URL
        }}assets/filtro-lateral-busca/button-ok.webp"
        alt=""
        width="89"
        height="36"
      />
    </button>
  </div>
</div>
